import React from 'react';
import PageHeader from '../shared/page-header';

const Contact = () => {
    return (
        <div>
            <PageHeader><span>Support and Contact Information</span></PageHeader>
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        <div>
                            <ul>
                                <li>Email: <a href="mailto:help@fmosoft.com">help@fmosoft.com</a></li>
                                <li>{'Phone: (407) 547-2438 (US Eastern Standard Time)'}</li>
                            </ul>
                            <p>In addition to email and phone support, we can also Skype if that works for you. If you have a decent internet connection (in theory, as low as 56K modem should work) we can direct you to a web site that will allow you to give us control of your computer. You will then be able to watch as we diagnose and fix a problem on your computer, or demonstrate a feature you have questions about.</p>
                            <p>Time zone differences are not a big issue. We can usually arrange to be available whenever is good for you.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
Contact.propTypes = {};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/contact.js